import { connect } from 'react-redux';
import {
  logout
} from "../../actions/App";
import {
  getInvitationByCode
} from "../../actions/CreateAccount";

import CreateClientAccountIndex from '../../components/CreateClientAccount/Index';

import {
  register
} from "../../actions/CreateClientAccount";

const mapStateToProps = (state) => {
  const {
    get_invitation_by_code,
    invitation_error_message
  } = state.create_account;

  const {
    ifRegisterSuccess,
    error_message
  } = state.create_client_account;

  return {
    get_invitation_by_code,
    ifRegisterSuccess,
    error_message,
    invitation_error_message
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      window.localStorage.clear();
      dispatch(logout());
    },
    getInvitationByCode: (code) => {
      dispatch(getInvitationByCode(code));
    },
    register: (code, obj, status) => {
      dispatch(register(code, obj, status));
    }
  }
}

const CreateClientAccount = connect (
  mapStateToProps,
  mapDispatchToProps
)(CreateClientAccountIndex);

export default  CreateClientAccount;



// WEBPACK FOOTER //
// ./src/containers/CreateClientAccount/index.js